export default __webpack_public_path__ + "819d411ee765159a7b07edf8a5803f97.png";